import { HyperLinkControl } from "@/Common/Components/Buttons/HyperLinkControl";
import { FeatureFlagControl } from "@/Common/Components/FeatureFlagControl";
import { LabActionInboxes, LabInboxes, LabTabViews } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ILabsTabModel } from "@/Labs/Models/UI/ILabsTabModel";

import styles from "./LabTreeControl.module.scss";

interface ILabTreeControlProps {
    Model: ILabsTabModel;

    NonApprovedLabCount: number;
    IsPatientNav: boolean;
    CurrentView?: LabTabViews;
    CurrentLabInbox: LabInboxes;
    CurrentActionInbox: LabActionInboxes ;
}

class LabTreeControl extends React.Component<ILabTreeControlProps, never> {
    public shouldComponentUpdate(nextProps: ILabTreeControlProps): boolean {
        const Inbox = this.props.CurrentLabInbox != nextProps.CurrentLabInbox;
        const ActionInbox = this.props.CurrentActionInbox != nextProps.CurrentActionInbox;
        const Counts = !Immutable.is(nextProps, this.props);
        return Counts || Inbox || ActionInbox;
    }

    public render(): JSX.Element {
        return (
            <div className="flex-container" style={{ justifyContent: "space-between", "flexDirection": "column", "height": "100%" }}>
                <div>  {/* Top Div */}
                    {this.props.IsPatientNav == false && (
                        <ul className={`${styles.accordionResultsNavigation} accordion`} data-accordion="">
                            <li className="accordion-navigation">
                                <div className="nav-btns">
                                    <div><a className="bold">{cacheStore.GetString("ResultsLabel") + " : "}</a></div>
                                    <div className="no-margin">
                                        <ul className={styles.navigationList}>
                                            <li><HyperLinkControl IsUnderLined={this.props.Model.get("CurrentView") == LabTabViews.Inbox && this.props.CurrentLabInbox === LabInboxes.All} operation={LocalOperations.Labs.SwitchTo_AllLabsInbox} text={cacheStore.GetString("AllLabInbox")} /></li>
                                            <li><HyperLinkControl IsUnderLined={this.props.Model.get("CurrentView") == LabTabViews.Inbox && this.props.CurrentLabInbox === LabInboxes.New} operation={LocalOperations.Labs.SwitchTo_NewLabsInbox} text={cacheStore.GetString("NewLabsInbox")} /></li>
                                            <FeatureFlagControl
                                                flag={cacheStore.ClinicSettings.EnableCentralizedManualLabsGrid && cacheStore.ClinicSettings.EnableManualEntryOfLabResults}
                                                activeFeature={(
                                                    <li data-cy="manual-results-inbox-link">
                                                        <HyperLinkControl IsUnderLined={this.props.Model.get("CurrentView") == LabTabViews.Inbox && this.props.CurrentLabInbox === LabInboxes.ManualResults} operation={LocalOperations.Labs.SwitchTo_LabManualResults} text={cacheStore.GetString("ManualResults_ManualResultsLabel")} />
                                                        <span className={styles.counter}>{" (" + this.props.Model.get("NewManualLabResultsCount") + ")"}</span>
                                                    </li>
                                                )}
                                                fallbackFeature={null}
                                            />
                                            <li><HyperLinkControl IsUnderLined={this.props.Model.get("CurrentView") == LabTabViews.Inbox && this.props.CurrentLabInbox === LabInboxes.Suspended} operation={LocalOperations.Labs.SwitchTo_SuspendedLabsInbox} text={cacheStore.GetString("OnHoldLabsInbox")} /></li>
                                            <li><HyperLinkControl IsUnderLined={this.props.Model.get("CurrentView") == LabTabViews.Inbox && this.props.CurrentLabInbox === LabInboxes.Classified} operation={LocalOperations.Labs.SwitchTo_ClassifiedLabsInbox} text={cacheStore.GetString("FiledLabsInbox")} /></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>

                            <li className="accordion-navigation margintop20">
                                <div className="nav-btns">
                                    <div><a className="bold">{cacheStore.GetString("ActionsLabel") + " : "}</a></div>
                                    <div className="no-margin">
                                        <ul className={styles.navigationList}>
                                            <li><HyperLinkControl IsUnderLined={this.props.Model.get("CurrentView") == LabTabViews.ActionsInbox && this.props.CurrentActionInbox === LabActionInboxes.All} operation={LocalOperations.Labs.SwitchTo_LabActionTous} text={cacheStore.GetString("AllLabInbox")} /><span style={{ color: "white" }}>{" (" + this.props.Model.get("ActionTotalCount") + ")"}</span></li>
                                            <li><HyperLinkControl IsUnderLined={this.props.Model.get("CurrentView") == LabTabViews.ActionsInbox && this.props.CurrentActionInbox === LabActionInboxes.Nurses} operation={LocalOperations.Labs.SwitchTo_LabActionNurses} text={cacheStore.GetString("NursesFLabel")} /><span style={{ color: "white" }}>{" (" + this.props.Model.get("ActionNursesCount") + ")"}</span></li>
                                            <li><HyperLinkControl IsUnderLined={this.props.Model.get("CurrentView") == LabTabViews.ActionsInbox && this.props.CurrentActionInbox === LabActionInboxes.Secretaries} operation={LocalOperations.Labs.SwitchTo_LabActionSecretaries} text={cacheStore.GetString("SecretariesFLabel")} /><span style={{ color: "white" }}>{" (" + this.props.Model.get("ActionSecretariesCount") + ")"}</span></li>
                                            <li><HyperLinkControl IsUnderLined={this.props.Model.get("CurrentView") == LabTabViews.ActionsInbox && this.props.CurrentActionInbox === LabActionInboxes.Completed} operation={LocalOperations.Labs.SwitchTo_LabActionCompleted} text={cacheStore.GetString("CompletedFLabel")} /></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>

                        </ul>
                    )}

                    {this.props.IsPatientNav === true && this.props.CurrentView === LabTabViews.Inbox && cacheStore.ClinicSettings.EnableManualEntryOfLabResults && (
                        <ul className="accordion" data-accordion="">
                            <li className="accordion-navigation">
                                <div className="nav-btns">
                                    <div className="no-margin">
                                        <ul>
                                            <li>
                                                <HyperLinkControl
                                                    className={styles.ManualResultsLink}
                                                    operation={LocalOperations.LabsUI.OpenManualEntryFormPopup}
                                                    dataCy="manualResultsEntry-addResults-link"
                                                >
                                                    <span className="plus_icon"> </span>
                                                    <span>{cacheStore.GetString("ManualResults_ManualResultsLabel")}</span>
                                                </HyperLinkControl>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    )}

                    {this.props.IsPatientNav === true && this.props.CurrentView === LabTabViews.Lab && (
                        <ul className="accordion" data-accordion="">
                            <li className="accordion-navigation">
                                <div className="nav-btns">
                                    <div className="no-margin">
                                        <ul style={{ marginLeft: "15px" }}>
                                            <li><HyperLinkControl IsUnderLined={false} operation={LocalOperations.Labs.SwitchTo_AllLabsInbox} text={cacheStore.GetString("BackToResultLabel")} /></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    )}
                    {this.props.IsPatientNav === true && this.props.CurrentView === LabTabViews.Graph && (
                        <ul className="accordion" data-accordion="">
                            <li className="accordion-navigation">
                                <div className="nav-btns">
                                    <div className="no-margin">
                                        <ul style={{ marginLeft: "15px" }}>
                                            <li><HyperLinkControl IsUnderLined={false} operation={LocalOperations.Labs.SwitchTo_OpenLab} text={cacheStore.GetString("LabResultsLabel")} /></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    )}

                </div>

                <div>
                    {/* Bottom Div */}
                </div>

                <div>
                    {/* End Div */}
                </div>
            </div>

        );
    }
}

export { LabTreeControl };
